import { FunctionComponent } from "react";
import { Layout, Row, Col } from "antd";

const { Footer } = Layout;

export const PublicFooter: FunctionComponent = () => (
    <Footer className="footer">
        <Row gutter={[16, 16]} justify="center">
            <Col xs={24} md={8} className="footer-section">
                <h3 className="footer-title">Association Musulmane du Chablais</h3>
                <p>5 chemin des Epinanches</p>
                <p>74200 Thonon-les-Bains</p>
                <p>
                    Tel: <a href="tel:+33450706478" className="footer-link">(+33) 4 50 70 64 78</a><br />
                    Email: <a href="mailto:amcinscription@gmail.com" className="footer-link">amcinscription@gmail.com</a>
                </p>
            </Col>
            <Col xs={24} md={8} className="footer-section">
                <h3 className="footer-title">Navigation</h3>
                <p><a href="/coursEnfants" className="footer-link">Cours enfants</a></p>
                <p><a href="/coursAdultes" className="footer-link">Cours adultes</a></p>
                <p><a href="/adhesionInfos" className="footer-link">Adhésion</a></p>
            </Col>
            <Col xs={24} md={8} className="footer-section">
                <h3 className="footer-title">Suivez-nous</h3>
                <div className="social-icons">
                    <a href="https://www.facebook.com/100012969094800" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                </div>
            </Col>
        </Row>
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <p> 2023 Association Musulmane du Chablais. Tous droits réservés.</p>
        </div>
    </Footer>
);
